import { render } from "./CorporateMovies.vue?vue&type=template&id=4574cca1"
import script from "./CorporateMovies.vue?vue&type=script&lang=js"
export * from "./CorporateMovies.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__